
import Vue from 'vue'
import { mapGetters } from 'vuex'

import NavDrawer from '@/ui/layouts/fragments/NavDrawer.vue'

import UserMenu from '@/ui/components/users/UserMenu.vue'
import JSnackbars from '@/ui/controls/JSnackbars.vue'
import JServiceWorkerUpdate from '@/ui/controls/JServiceWorkerUpdate.vue'

import JCenterCol from '@/ui/controls/JCenterCol.vue'
import Login from '@/ui/components/users/Login.vue'

export default Vue.extend({
  name: 'BaselineLayout',

  components: {
    NavDrawer,

    JCenterCol,
    Login,

    JSnackbars,
    JServiceWorkerUpdate,

    UserMenu,
  },

  props: {
    showToolbarExtension: Boolean,
    showTitleComponent: Boolean,
    hideToolbarOnScroll: Boolean,

    title: String,
  },

  data: () => ({
    drawer: null as null | boolean,
  }),

  computed: {
    ...mapGetters({
      user: 'user',
      isUserLoading: 'isUserLoading',

      updateExists: 'sw/updateExists',
    }),
  },

  methods: {
    //
  },
})
